import {
    ChartsState,
    FetchChartsActionTypes,
    FETCH_CHARTS_STARTED,
    FETCH_CHARTS_SUCCESS
  } from "./types";
// import { getCategory } from "./functions";

const initialState: ChartsState = {
    items: [],
    isFetching:false,
    error: {},
};

export function chartsReducer(
    state=initialState,
    action: FetchChartsActionTypes
):ChartsState {
    switch(action.type){
        case FETCH_CHARTS_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case FETCH_CHARTS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: action.charts
            })
        default:
            return state;
    }

} 